import React from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { tokens } from "../theme/theme";

const LeadTargetGauge = ({ value = 10, target = 1000 }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const percentage = (value / target) * 100;

    return (
        <Paper elevation={1} sx={{ p: 2, height: "100%", borderRadius: 2,backgroundColor:colors.primary[500] }}>
            <Typography fontSize={14} fontWeight={600} mb={2}>
                LEAD GENERATION TARGET - THIS YEAR
            </Typography>
            <Box sx={{ height: 200, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Box sx={{ width: 180 }}>
                    <CircularProgressbar
                        value={percentage}
                        text={`${value}`}
                        styles={buildStyles({
                            textSize: "16px",
                            pathColor: "#3f51b5",
                            textColor: "#000",
                            trailColor: "#e0e0e0",
                        })}
                    />
                </Box>
            </Box>
            <Typography variant="body2" textAlign="center" mt={1}>
                Remaining: {target - value}
            </Typography>
        </Paper>
    );
};

export default LeadTargetGauge;
